import Typed from 'typed.js';
if (document.getElementById('blog-topics')) {
    new Typed('#blog-topics', {
        strings: [
            "Learning",
            "JavaScript",
            "PHP",
            "Angular",
            "Symfony",
            "React",
            "TypeScript",
            "Node.js",
            "A Human-being",
            "Software Development",
            "Open Source",
            "Sharing knowledge",
            "Perspectives",
            "Next.js",
            "the web",
        ],
        typeSpeed: 50,
        backSpeed: 50,
        shuffle: true,
        backDelay: 1000,
        loop: true
    });
}
